import React, { Component } from 'react'
import { observer } from 'mobx-react';
import { HashRouter } from 'react-router-dom'

import Headers from './head'
import Bar from './bar'
import Content from './content'


@observer
export default class App extends Component {
  render() {

    return (
      <HashRouter>
        <div className="pr oh">
          <Headers />
          <Bar />
          <Content />
        </div>
      </HashRouter>
    )
  }
}

